// removed by extract-text-webpack-plugin
module.exports = {"Container":"_3Xoep","TagWrapper":"_2EvGP","ContainerPrimary":"_3wu08","ContainerSecondary":"_3gTXN","Box1":"_2imAi","Box2":"_b8R5C","AirlineDetail":"_3XlO7","Dash":"_1lbU5","Change":"_1hGlF","SolidBorder":"_2rCYF","VerticalDivider":"_TR9gO","Stopover":"_1wYCq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/TupleStackedMobile/TupleStackedMobile.scss
// module id = 528
// module chunks = 0